import React from 'react';
import { Link } from 'react-router-dom';
import { healthColor } from './HealthBadge';

export default function IssuesList({ issues = [], max = 12, emptyText = 'Sin problemas detectados' }) {
  if (!issues.length) {
    return <p style={{ color: '#8392a5', fontSize: 13, margin: 0 }}>{emptyText}</p>;
  }
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {issues.slice(0, max).map((iss, idx) => (
        <li
          key={`${iss.tipo}-${iss.entidad}-${idx}`}
          style={{
            display: 'flex',
            gap: 10,
            padding: '8px 0',
            borderBottom: '1px solid #f5f6fa',
            fontSize: 13,
            alignItems: 'flex-start',
          }}
        >
          <span
            style={{
              marginTop: 4,
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: healthColor(iss.severidad === 'critical' ? 'critical' : 'warning'),
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, color: '#001737' }}>
              {iss.entidad}
              <span style={{ marginLeft: 8, fontWeight: 500, color: '#8392a5', fontSize: 11 }}>
                {iss.tipo}
              </span>
            </div>
            <div style={{ color: '#8392a5' }}>{iss.detalle}</div>
          </div>
          {iss.link ? (
            <Link to={iss.link} style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
              Ver
            </Link>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
